import React from "react";
import { Route, Switch } from "react-router";
import SignIn from "../../screens/SignIn";

const EntryRoutes = () => {
  return (
    <Switch>
      <Route path="/" component={SignIn} />
    </Switch>
  );
};

export default EntryRoutes;
